import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadIntervalEpic } from './_epics/loadInterval.epic';
import { updateIntervalEpic } from './_epics/updateInterval.epic';
import { removeIntervalEpic } from './_epics/removeInterval.epic';
import { viewIntervalsEpic } from './_epics/viewIntervals.epic';
import { reloadIntervalEpic } from './_epics/reloadInterval.epic';
import { onRemoveScheduleEpic } from './_epics/onRemoveSchedule.epic';

export const scheduleIntervalEpic = safeCombineEpics(
  loadIntervalEpic,
  reloadIntervalEpic,
  onRemoveScheduleEpic,
  updateIntervalEpic,
  removeIntervalEpic,
  viewIntervalsEpic,
);
